import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import CustomModal from "../../packages/CustomModal";
import IconButton from "../../packages/IconButton";

import CIPPaginatedTable from "../../components/CIPPaginatedTable";

import { QuestionIcon } from "../../assets/icons";

import IconWithTooltip from "../../common/styles/components/headings/IconWithTooltip";

const HistoricalCIPs = () => {
  const { t } = useTranslation();
  const cips = useSelector((state) => state.cips);
  const selectedTrain = useSelector((state) => state.selTrain);
  const isCipsEmpty = !cips || cips.length === 0;
  const errorMessage = t("IdentifiedCIPStrings.noCip");
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  const onHelpBtnClick = () => {
    setHelpDialogOpen(true);
  };

  const onHelpDialogClose = () => {
    setHelpDialogOpen(false);
  };

  return (
    <div className="ro-card-wrapper">
      <div className="ro-card-header">
        <div className="info-section">
          <div className="teal-heading">{t("CIPShutdownStrings.title")}</div>
          <IconWithTooltip label={t("helpInformation.cipTableTooltip")} />
        </div>
        <IconButton id="help-dialog-btn" onClick={onHelpBtnClick}>
          <QuestionIcon />
        </IconButton>
      </div>
      <CIPPaginatedTable
        selectedTrain={selectedTrain}
        exportFileName={t("excelSheetNames.cipsAndPlantShutdowns")}
        enableActions
        enableAdd
        historicOnly
        {...(isCipsEmpty ? { errorMessage } : {})}
      />

      {helpDialogOpen && (
        <CustomModal
          show={helpDialogOpen}
          header={t("helpInformation.cipTableHelp")}
          onModalClose={onHelpDialogClose}
          confirmBtn={t("ValueStrings.okay")}
          size="small"
          width="575px"
        >
          <div className="help-dialog-content">
            <div className="help-section">
              <div className="help-heading">
                {t("helpInformation.fewerCIPsHeading")}
              </div>
              <ul className="help-list">
                <li className="help-list-item">
                  {t("helpInformation.fewerCIPsManualAdd")}
                </li>
                <li className="help-list-item">
                  {t("helpInformation.fewerCIPsOpenSettings")}
                  <ul className="help-nested-list">
                    <li className="help-nested-list-item">
                      {t("helpInformation.fewerCIPsLowerResolution")}
                    </li>
                    <li className="help-nested-list-item">
                      {t("helpInformation.fewerCIPsReduceMinPoints")}
                    </li>
                    <li className="help-nested-list-item">
                      {t("helpInformation.fewerCIPsIncreaseMedianPoints")}
                    </li>
                    <li>{t("helpInformation.fewerCIPsReduceThreshold")}</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="help-section">
              <div className="help-heading">
                {t("helpInformation.moreCIPsHeading")}
              </div>
              <ul className="help-list">
                <li className="help-list-item">
                  {t("helpInformation.moreCIPsManualDelete")}
                </li>
                <li>
                  {t("helpInformation.moreCIPsOpenSettings")}
                  <ul className="help-nested-list">
                    <li className="help-nested-list-item">
                      {t("helpInformation.moreCIPsIncreaseResolution")}
                    </li>
                    <li className="help-nested-list-item">
                      {t("helpInformation.moreCIPsIncreaseMinPoints")}
                    </li>
                    <li className="help-nested-list-item">
                      {t("helpInformation.moreCIPsReduceMedianPoints")}
                    </li>
                    <li>{t("helpInformation.moreCIPsIncreaseThreshold")}</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default HistoricalCIPs;
